import buttons from '../../views/pages/main/buttons';
import types from './types';

const InitialState = {
    loaded: false,
    user: null,
    tasks: null,
    wallet: null,
    bitcoin: null,
    clouds: null,
    paypal_links: null,
    paypal_order: null,
    cashapp: {
        initialized: false,
        request: false
    },
    chime_recipient: null,
    chime_order: null,
    cashapp_recipient: null,
    cashapp_order: null,
    cashapp_cashout: null,
    square_order: null,
    payou_order: null,
    cashapp_merchant_order: null,
    modal_tx: null,
    modal_alert: null,
    modal_qr: null,
    modal_halloween: null,
    modal_halloween_data: null,
    bitcoin_profit: null,
    bitcoin_cashout: null,
    buttons: {
        verification: false,
        create_square_order: false,
        create_payou_order: false,
        create_cashapp_merchant_order: false,
        create_bitcoin_cashout: false,
        confirm_bitcoin_cashout: false,

        chime_create_button: false,
        cashapp_create_button: false,
        create_cashapp_cashout: false,
        confirm_cashapp_cashout: false,
        cancel_cashout: false,
        claim_cashback: false,
        halloween: false
    }
}

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        // case types.halloween_gifts:
        //     return {
        //         ...state,
        //         wallet: {
        //             ...state.wallet,
        //             halloween: {
        //                 ...state.wallet.halloween,
        //                 my_gifts: payload
        //             }
        //         }
        //     }
        // case types.modal_halloween_data:
        //     return {
        //         ...state,
        //         modal_halloween_data: payload
        //     }
        // case types.modal_halloween:
        //     return {
        //         ...state,
        //         modal_halloween: payload
        //     }
        case types.cashback_redeem:
            return {
                ...state,
                wallet: {
                    ...state,
                    cashback: {
                        ...state.wallet.cashback,
                        balance: 0
                    },
                    balance: payload
                }
            }
        case types.cashapp.confirmed:
            return {
                ...state,
                cashapp: {
                    ...state.cashapp,
                    request: {
                        ...state.cashapp.request,
                        confirmed: true
                    }
                }
            }
        case types.cashapp.request:
            return {
                ...state,
                cashapp: {
                    ...state.cashapp,
                    request: payload
                }
            }
        case types.cashapp.reset:
            return {
                ...state,
                cashapp: InitialState.cashapp
            }
        case types.cashapp.initialized:
            return {
                ...state,
                cashapp: {
                    ...state.cashapp,
                    initialized: true
                }
            }
        case types.cashback: 
            return {
                ...state,
                wallet: {
                    ...state.wallet,
                    cashback: {
                        ...payload,
                        timestamp: Date.now() + payload.timestamp
                    },
                }
            }
        case types.cashapp_merchant_order:
            return {
                ...state,
                cashapp_merchant_order: payload
            }
        case types.payou_order:
            return {
                ...state,
                payou_order: payload
            }
        case types.square_order:
            return {
                ...state,
                square_order: payload
            }
        case types.bitcoin_cashout_approved:
            return {
                ...state,
                bitcoin_cashout: state.bitcoin_cashout ? {
                    ...state.bitcoin_cashout,
                    status: "confirmed"
                } : state.bitcoin_cashout
            }
        case types.bitcoin_cashout:
            return {
                ...state,
                bitcoin_cashout: payload
            }
        case types.modal_qr:
            return {
                ...state,
                modal_qr: payload
            }
        case types.verification:
            return {
                ...state,
                wallet: {
                    ...state.wallet,
                    ...payload
                }
            }
        case types.toggleButton:
            return {
                ...state,
                buttons: {
                    ...state.buttons,
                    [payload]: !state.buttons[payload]
                }
            }
        case types.tasks:
            return {
                ...state,
                tasks: payload.map(task => {
                    return {
                        ...task,
                        timeout: task.timeout ? (task.timeout + Date.now()) : 0,
                        disabled: false
                    }
                })
            }
        case types.tasks_toggle:
            return {
                ...state,
                tasks: state.tasks.map(task => {
                    return task.key === payload ? {
                        ...task,
                        disabled: !task.disabled
                    } : task;
                })
            }
        case types.bitcoin_profit:
            return {
                ...state,
                bitcoin_profit: payload
            }
        case types.modal_alert:
            return {
                ...state,
                modal_alert: payload
            }
        case types.paypal_order:
            return {
                ...state,
                paypal_order: payload
            }
        case types.paypal_links:
            return {
                ...state,
                paypal_links: payload
            }
        case types.balance:
            return {
                ...state,
                wallet: {
                    ...state.wallet,
                    balance: payload
                }
            }
        case types.cashapp_cashout:
            return {
                ...state,
                cashapp_cashout: payload
            }
        case types.modal_tx:
            return {
                ...state,
                modal_tx: payload
            }
        case types.transaction:
            const tx_exist = state.wallet.transactions.filter(tx => tx.transaction_id === payload.transaction_id)[0] || false;

            if(tx_exist)
                return {
                    ...state,
                    wallet: {
                        ...state.wallet,
                        transactions: state.wallet.transactions.map(tx => {
                            return tx.transaction_id === payload.transaction_id ? {
                                ...payload,
                                timestamp: Date.now() + payload.timestamp
                            } : tx;
                        })
                    }
                }

            return {
                ...state,
                wallet: {
                    ...state.wallet,
                    transactions: [
                        {
                            ...payload,
                            timestamp: Date.now() + payload.timestamp
                        },
                        ...state.wallet.transactions
                    ]
                }
            }
        case types.cashapp_order:
            return {
                ...state,
                cashapp_order: payload
            }
        case types.cashapp_recipient:
            return {
                ...state,
                cashapp_recipient: payload
            }

        case types.chime_order:
            return {
                ...state,
                chime_order: payload
            }
        case types.chime_recipient:
            return {
                ...state,
                chime_recipient: payload
            }
        case types.chime_reset:
            return {
                ...state,
                chime_order: InitialState.chime_order,
                chime_recipient: InitialState.chime_recipient
            }
        case types.user:
            return {
                ...state,
                user: payload
            }
        case types.loaded:
            return {
                ...state,
                loaded: true,
                tasks: payload.tasks.map(task => {
                    return {
                        ...task,
                        timeout: task.timeout ? (task.timeout + Date.now()) : 0
                    }
                }),
                wallet: {
                    ...payload.wallet,
                    cashback: {
                        ...payload.wallet.cashback,
                        timestamp: Date.now() + payload.wallet.cashback.timestamp
                    },
                    // halloween: {
                    //     ...payload.wallet.halloween,
                    //     timestamp: Date.now() + payload.wallet.halloween.timestamp
                    // }, 
                    transactions: payload.wallet.transactions.map(tx => {
                        return {
                            ...tx,
                            timestamp: Date.now() + tx.timestamp,
                            disabled: false
                        }
                    }).sort((a,b) => {
                        if(a.timestamp > b.timestamp) return -1;
                        if(a.timestamp < b.timestamp) return 1;
                        return 0;
                    })
                },
                bitcoin: payload.bitcoin,
                clouds: payload.clouds
            }
        default:
            return state;
    }
}